import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { InviteUserDto } from '@/types/settings';

interface InviteResponse {
  inviteId: string;
  tenantId: string;
  companyId: string;
  email: string;
  expiresAt: string;
  roleIds: string[];
  claimToken: string;
}

export function useInviteUser() {
  const queryClient = useQueryClient();

  return useApiMutation<InviteResponse, InviteUserDto>({
    mutationFn: (dto) =>
      apiPost<InviteResponse, InviteUserDto>(operationsClient, settingsEndpoints.inviteUser(), dto),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: settingsKeys.users() });
      toast.success('Invite link created');
    },
  });
}
